import { LinkedIn, Instagram } from '@mui/icons-material';
import React from 'react';
import styled from 'styled-components';

const team = [
  {
    id: 0,
    name: "Bhavy Zala",
    email: "22bce395@nirmauni.ac.in",
    profileImg: "https://i.postimg.cc/QM0QYpc1/Bhavy.png",
    social: {
      LinkedIn: "https://www.linkedin.com/in/bhavy-zala-59bb76241?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      Instagram: "https://www.instagram.com/bhavy_zala499?igsh=ZXR1NzNzMDYwcXVn"
    }
  },
  {
    id: 1,
    name: "Shivam Patel",
    email: "21bce281@nirmauni.ac.in",
    profileImg: "https://i.postimg.cc/15wYCjXF/Shivam.png",
    social: {
      LinkedIn: "https://www.linkedin.com/in/shivam3103patel?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      Instagram: "https://www.instagram.com/shivam_n_patel?igsh=MjR1c2JlNjljMjMy"
    }
  },
];

const Title = styled.h2`
  font-size: 42px;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin-top: 60px;
  @media (max-width: 768px) {
    font-size: 32px;
    margin-top: 100px;
  }
`;

// padding: 0 250px;
// padding: 0 60px; 
// padding: 0 60px; 
const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    
  }
     @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    
  }
  margin-bottom: 40px;
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.card};
  border: 1px solid #854ce6;
  border-radius: 16px;
  padding: 20px;
  max-width : 80%;
  margin-left:10%;
  transition: transform 0.3s ease-in-out;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  &:hover {
    transform: scale(1.03);
  }
  @media (max-width: 768px) {
    flex-direction: row; 
    text-align: left; 
  }
`;

const ProfileImg = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
  @media (max-width: 768px) {
    width: 60px; 
    height: 60px;
    margin-right: 15px; 
  }
`;

const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ProfileName = styled.h3`
  font-size: 1.5rem;
  margin: 0;
  color: ${({ theme }) => theme.text_primary};
`;

const ProfileEmail = styled.a`
  font-size: 1rem;
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  margin: 5px 0;
  word-break: break-word; // This ensures long emails wrap within the div
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 768px) {
    font-size: 0.85rem; // Decrease the font size for mobile screens
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  @media (max-width: 768px) {
    margin-top: 5px; 
  }
`;

const SocialIcon = styled.a`
  font-size: 1.5rem; 
  color: ${({ theme }) => theme.primary};
  &:hover {
    color: ${({ theme }) => theme.text_secondary};
  }
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Achievements = () => {
  return (
    <div id="achievements">
      <Title>Our Website Developers</Title>
      <TeamGrid>
        {team.map((member) => (
          <Card key={member.id}>
            <ProfileImg src={member.profileImg} alt={member.name} />
            <ProfileInfo>
              <ProfileName>{member.name}</ProfileName>
              <ProfileEmail href={`mailto:${member.email}`}>{member.email}</ProfileEmail>
              <SocialIcons>
                <SocialIcon href={member.social.LinkedIn} target="_blank" rel="noopener noreferrer">
                  <LinkedIn />
                </SocialIcon>
                <SocialIcon href={member.social.Instagram} target="_blank" rel="noopener noreferrer">
                  <Instagram />
                </SocialIcon>
              </SocialIcons>
            </ProfileInfo>
          </Card>
        ))}
      </TeamGrid>
    </div>
  );
};

export default Achievements;
